import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { IMAGES } from '../i18n';

const Hero = ({ t }) => {
  return (
    <section id="section-1" className="relative py-16 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-ink leading-tight">
                {t.title}
              </h1>
              <p className="text-lg sm:text-xl text-slate-600 leading-relaxed">{t.subtitle}</p>
            </div>

            <div className="flex justify-start">
              <a
                href="/s"
                className="inline-flex items-center px-8 py-4 bg-primary text-white rounded-xl font-semibold text-lg hover:bg-teal-700 transition-colors duration-200 shadow-lg"
              >
                <span>{t.cta}</span>
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </div>

            <div className="flex items-center space-x-2 text-primary">
              <Sparkles className="w-5 h-5" />
              <span className="text-sm font-medium">{t.poweredBy}</span>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={IMAGES.hero}
                alt={t.imageAlt}
                className="w-full h-80 sm:h-96 lg:h-[500px] object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/25 to-transparent" />
            </div>

            <div className="absolute -top-4 -right-4 bg-white rounded-full p-4 shadow-lg">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-primary" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
